import { createElement } from 'react'
import { ComponentType } from 'react'
import {
  CmsLink,
  CmsText,
  CmsImage,
  CmsTicker,
  CmsHeading,
  CmsLinkText,
  CmsAnnotation,
  CmsBreadcrumb,
  CmsBreadcrumbs,
  CmsVideoInline,
  CmsContentsCard,
  CmsImagePlusText,
  CmsImagePlusTextCollection,
  CmsSpacer,
} from 'shared-global-ec-uikit/components/dist/react/esm'

export type CMSExportsType = {
  CmsText: ComponentType<any>
  CmsLink: ComponentType<any>
  CmsImage: ComponentType<any>
  CmsTicker: ComponentType<any>
  CmsHeading: ComponentType<any>
  CmsLinkText: ComponentType<any>
  CmsAnnotation: ComponentType<any>
  CmsBreadcrumb: ComponentType<any>
  CmsBreadcrumbs: ComponentType<any>
  CmsVideoInline: ComponentType<any>
  CmsContentsCard: ComponentType<any>
  CmsImagePlusText: ComponentType<any>
  CmsImagePlusTextCollection: ComponentType<any>
  CmsSpacer: ComponentType<any>
}

const CMSComponentsExport: CMSExportsType = {
  CmsText,
  CmsLink,
  CmsImage,
  CmsTicker,
  CmsHeading,
  CmsLinkText,
  CmsAnnotation,
  CmsBreadcrumb,
  CmsBreadcrumbs,
  CmsVideoInline,
  CmsContentsCard,
  CmsImagePlusText,
  CmsImagePlusTextCollection,
  CmsSpacer,
}

type Props = {
  key?: string
  [key: string]: any
  gaCallback?: (param: HTMLElement) => void
  cmsABPath?: string
}

export type CMSComponentSchema = {
  _type: string
  [prop: string]: any
}

function createComponentNode({
  component,
  index,
  base,
  CMSComponents,
  pageUrl = '',
  translations,
  CMSProperties,
  cmsABPath,
}: {
  component: CMSComponentSchema
  index: number
  base: string
  CMSComponents: any
  pageUrl: string
  translations?: { [key: string]: string }
  CMSProperties?: { [key: string]: string }
  cmsABPath?: string
}) {
  if (component._type) {
    const componentProps: Props = {}
    componentProps.key = `${base}.${index}`

    Object.keys(component).forEach(key => {
      const propValue = component[key]

      // To make sure It is array and have component (_type key is available only for component)
      if (Array.from(propValue).length && propValue[0] && propValue[0]._type) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        componentProps[key] = parseComponent({
          list: propValue,
          base: componentProps.key as string,
          pageUrl,
          translations,
          CMSProperties,
          cmsABPath,
        })
      } else {
        componentProps[key] = propValue
      }
    })

    if (!componentProps.children) {
      delete componentProps.children
    }

    if (!CMSComponents[component._type]) {
      delete componentProps._type
    }

    if (cmsABPath) {
      componentProps.cmsABPath = cmsABPath
    }
    return createElement(
      CMSComponents[component._type] || component._type,
      componentProps,
    )
  }

  return null
}

export const parseComponent = ({
  list,
  base = '0',
  pageUrl = '',
  translations,
  CMSProperties,
  cmsABPath,
}: {
  list: Array<any>
  base?: string
  pageUrl?: string
  translations?: { [key: string]: string }
  CMSProperties?: { [key: string]: string }
  cmsABPath?: string
}) => {
  let components = null
  if (Array.from(list).length) {
    components = list.map((component, index) => {
      try {
        return createComponentNode({
          component,
          index,
          base,
          CMSComponents: CMSComponentsExport,
          pageUrl,
          translations,
          CMSProperties,
          cmsABPath,
        })
      } catch (error) {
        return null
      }
    })
  }

  return components
}
